import * as types from './action-types'

export function fetchAlerts(id_gt = null, employer_id = null) {
  return { type: types.ADMIN_ALERTS_FETCH_BEGIN, id_gt, employer_id }
}

export function markAlertsAsNotified(ids = []) {
  return { type: types.ADMIN_ALERTS_MARK_AS_NOTIFIED, ids }
}
